import { FracGroupBase } from './base/frac-group-base';

export class FracGroup extends FracGroupBase { }